import React from 'react';
import TextField from '@material-ui/core/TextField';

import { db } from '../../firebase';
import avatar from '../../store/assets/davatar.png';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';


const FIREBASE_REF_PROFILE = db.ref('Users');
const FIREBASE_REF_MESSAGES = db.ref('Messages');


const withSearch = BaseComponent => {
    return class extends React.Component {
        constructor(props) {
            super(props)
            this.onSearchUpdate = this.onSearchUpdate.bind(this)
            this.state = {
                conversationList: [],
                searchDisabled: true,
                filteredConversationList: []
            }
            this.pullConversation();
        }

        onSearchUpdate(evt) {
            var filteredConversationList = this.state.conversationList.filter(list => {
                if (list.name) {
                    return list.name.toLowerCase().indexOf(evt.target.value.toLowerCase()) > -1
                }
            })
            this.setState({filteredConversationList})
        }

        getTime(epoch) {
            var d = new Date(epoch)
            // var date = d.getDate() 
            // + ' ' + d.toLocaleDateString('en-us', {month: 'short'})
            // + ', ' + d.getFullYear()
            var time = ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2)
            return time
        }

        orderConversationDescending(convoList) {
            return convoList.sort((a, b) => {
                return  (a.read - b.read) || (b.epochTime - a.epochTime)
            }).slice(0, 500)
        }

        pullConversation() {
            var welcomeMessage = "Welcome to Horas!"
            FIREBASE_REF_MESSAGES.on('value', snapshot => {
                var lastMessageTimeList = []
                var lastMessagesList = []
                var messagingUserIdList = []
                var conversationList = []
                var lastMessagingUsers=[]
                var epochTimeList = []
                snapshot.forEach(child => {
                    var messageList = child.val()
                    var messageKeys = Object.keys(messageList);
                    var lastMessageKey = messageKeys[messageKeys.length - 1]
                    var lastMessage = messageList[lastMessageKey].text
                    var lastMessageTime = this.getTime(messageList[lastMessageKey].createdAt)
                    var epochTime = messageList[lastMessageKey].createdAt
                    //var messagingUserId = messageList[lastMessageKey].user._id
                    var lastMessagingUser = messageList[lastMessageKey].user["_id"]
                    if (!lastMessage.includes(welcomeMessage)) {
                        lastMessageTimeList.push(lastMessageTime)
                        lastMessagesList.push(lastMessage)
                        messagingUserIdList.push(child.key)
                        lastMessagingUsers.push(lastMessagingUser)
                        epochTimeList.push(epochTime)
                    }
                })
                FIREBASE_REF_PROFILE.once('value').then(pSnapshot => {
                  var userList = pSnapshot.val()
                  var userDetails = messagingUserIdList.map(id => {
                    return userList[id]
                  })
                  userDetails.forEach((detail, i) => {
                    if(!detail) return
                    var temp =  {
                      name: detail.name,
                      avatar: detail.avatar ? detail.avatar : avatar,
                      lastMessage: lastMessagesList[i],
                      userId: messagingUserIdList[i],
                      lastMessageTime: lastMessageTimeList[i],
                      read: messagingUserIdList[i] !== lastMessagingUsers[i] && lastMessagingUsers[i] !== "YwoUFx6DwJduNAs13vywxiaaeJx1",
                      epochTime: epochTimeList[i]
                    }
                    conversationList.push(temp)
                  })
                  this.setState({conversationList: this.orderConversationDescending(conversationList)})
                  this.setState({filteredConversationList: this.orderConversationDescending(conversationList)})
                  this.setState({searchDisabled: false})
                })
            })
        }

        render() {
            return (
                <div>
                    <TextField
                        InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <SearchIcon />
                              </InputAdornment>
                            ),
                          }}
                        id="standard-with-placeholder"
                        //label="Search for User"
                        placeholder="Search for User"
                        onChange={this.onSearchUpdate}
                        margin="normal"
                        style={{width: '100%', marginLeft: '1%', marginRight: '1%', height: '8%'}}
                    />
                    <BaseComponent conversationList={this.state.filteredConversationList} {...this.props} />
                </div>
            )
        }
    }
}

export default withSearch


// WEBPACK FOOTER //
// ./src/Components/Dashboard/withSearch.js